export const HEADER_HEIGHT = '50px' as const;
